import React, {  } from "react";
import { Poi } from "../../../types";

interface PoiEditorProps {
  poi: Poi;
}

const PoiEditor: React.FC<PoiEditorProps> = ({ poi }) => {
  return (
    <iframe 
      src={`${window.origin}/wp-admin/post.php?post=${poi.id}&action=edit&simple_editor=1`} 
      title={poi.title} 
      style={{ width: "100%", height: "100%", border: "none", backgroundColor: "#fff", paddingTop: "64px" }} 
    />
  );
};
export default PoiEditor;